
<h1 class="page-title">Home</h1>

<div class="container">
  <p>Main page text</p>
</div>
